<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6084 6.47533C14.55 6.46699 14.4917 6.46699 14.4334 6.47533C13.1417 6.43366 12.1167 5.37533 12.1167 4.07533C12.1167 2.75033 13.1917 1.66699 14.525 1.66699C15.85 1.66699 16.9334 2.74199 16.9334 4.07533C16.925 5.37533 15.9 6.43366 14.6084 6.47533Z"
      fill="#292D32"
    />
    <path
      d="M17.3249 12.2503C16.3916 12.8753 15.0833 13.1087 13.8749 12.9503C14.1916 12.267 14.3583 11.5087 14.3666 10.7087C14.3666 9.87534 14.1833 9.08367 13.8333 8.392C15.0666 8.22534 16.3749 8.45867 17.3166 9.08367C18.6333 9.95034 18.6333 11.3753 17.3249 12.2503Z"
      fill="#292D32"
    />
    <path
      d="M5.36672 6.47533C5.42505 6.46699 5.48338 6.46699 5.54172 6.47533C6.83338 6.43366 7.85838 5.37533 7.85838 4.07533C7.85838 2.74199 6.78338 1.66699 5.45005 1.66699C4.12505 1.66699 3.05005 2.74199 3.05005 4.07533C3.05005 5.37533 4.07505 6.43366 5.36672 6.47533Z"
      fill="#292D32"
    />
    <path
      d="M5.45843 10.7079C5.45843 11.5162 5.63343 12.2829 5.9501 12.9745C4.7751 13.0995 3.5501 12.8495 2.6501 12.2579C1.33343 11.3829 1.33343 9.95785 2.6501 9.08285C3.54176 8.48285 4.8001 8.24118 5.98343 8.37452C5.64176 9.07452 5.45843 9.86618 5.45843 10.7079Z"
      fill="#292D32"
    />
    <path
      d="M10.1 13.225C10.0333 13.2167 9.95833 13.2167 9.88333 13.225C8.35 13.175 7.125 11.9167 7.125 10.3667C7.13333 8.78333 8.40833 7.5 10 7.5C11.5833 7.5 12.8667 8.78333 12.8667 10.3667C12.8583 11.9167 11.6417 13.175 10.1 13.225Z"
      fill="#292D32"
    />
    <path
      d="M7.39175 14.9502C6.13341 15.7919 6.13341 17.1752 7.39175 18.0085C8.82508 18.9669 11.1751 18.9669 12.6084 18.0085C13.8667 17.1669 13.8667 15.7835 12.6084 14.9502C11.1834 13.9919 8.83341 13.9919 7.39175 14.9502Z"
      fill="#292D32"
    />
  </svg>
</template>

<script>
export default {
  name: "UserActiveIcon",

  data() {
    return {};
  },
  computed: {},
};
</script>